import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';

interface QuickAddButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export const QuickAddButton = ({ onClick, disabled, className = '' }: QuickAddButtonProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileHover={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className={className}
    >
      <Button
        onClick={onClick}
        disabled={disabled}
        className="w-full bg-brand-primary hover:bg-brand-primary/90 text-white"
        size="lg"
      >
        <ShoppingCart className="w-4 h-4 mr-2" />
        Quick Add
      </Button>
    </motion.div>
  );
};
